import React, {Component, createRef} from 'react';
import './MaxButton.css';
import gsap from 'gsap';
import PropTypes from "prop-types";
import {getFM} from "../Utilities/utils";
import {withRouter} from "react-router";
import {Link} from "react-router-dom";
import {RArrowIcon} from "./menu/MenuIcons";

class MaxButton extends Component {

    constructor(props) {
        super(props);
        this.bid = createRef();
        this.xButton = createRef();
        this.xbCircle = createRef();
        this.xbRight = createRef();
        this.xbLeft = createRef();
        this.anim = gsap.timeline({paused: true});
    }

    componentDidMount() {
        if (!this.props.clickRoute) {
            this.xButton.current.onclick = this.props.clickEvent?
                this.props.clickEvent :
                () => this.props.history.push('/' + this.props.clickRoute );
        }

        let arrowH = this.xbRight.current.getBoundingClientRect().height * 1.2;

        this.anim.fromTo(this.xbCircle.current, {
            marginLeft: "calc(var(--lh) * 0.1)",
            marginRight: "calc(var(--lh) * 0.1)",
        },{
            duration: 0.5,
            marginLeft: "calc(var(--lh) * 0.7)",
            marginRight: "calc(var(--lh) * -0.5)",
        }).fromTo(this.xbLeft.current, {
            marginLeft: "calc(var(--lh) * -0.4)",
            height: arrowH,
            width: arrowH,
            opacity: 0,
        },{
            duration: 0.5,
            opacity: 1,
            marginLeft: "calc(var(--lh) * 0.3)",
            height: arrowH,
            width: arrowH,
        }, '0');
    }

    onMouseEnterHandler = () => {
        this.anim.play();
    }

    onMouseLeaveHandler = () => {
        this.anim.reverse();
    }

    render() {

    return (<>
        {this.props.clickRoute &&
                <Link to={{pathname:`/${this.props.clickRoute}${this.props.location.search? '/'+this.props.location.search : ''}`,state: { openService: this.props.service}}} >
                    {this.getContent()}
                </Link>}
           {!this.props.clickRoute && this.getContent()}
        </>)
    }

    getContent() {
        return <div ref={this.bid} id={this.props.id}
                    className={this.props.className + " accessibility-img"}
                    style={{color: this.props.color, backgroundColor: this.props.bgColor}} >

            <div ref={this.xButton}
                      onMouseOver={this.onMouseEnterHandler}
                      onMouseOut={this.onMouseLeaveHandler}
                      className={"x-button-content accessibility-font clickable"}
                      >
                <div ref={this.xbLeft} className={"left-arrow"}>
                    <RArrowIcon />
                </div>

                <span className={"x-button-text"}>
                    {getFM(this.props.children)}
                </span>
                <div ref={this.xbCircle} className={"circle"}
                     style={{backgroundColor: this.props.color, color: this.props.bgColor}}>
                    <div ref={this.xbRight} className={"right-arrow"}>
                        <RArrowIcon />
                    </div>
                </div>
            </div>
        </div>;
    }
}

MaxButton.propTypes = {
    id: PropTypes.string,
    children: PropTypes.string,
    clickEvent: PropTypes.func,
    clickRoute: PropTypes.string,
    bgColor: PropTypes.string,
    color: PropTypes.string,
    className: PropTypes.string,
    service: PropTypes.string
}

MaxButton.defaultProps = {
    id:'',
    className: 'x-button',
    bgColor: '#EE303B',
    color: '#fff',
    service: ""
}

export default withRouter(MaxButton);
